define(
    'views/profile-info',[
        'jquery',
        'settings',
        'utils/form-poster',
        'utils/view',
        'utils/form-validator',
        'utils/translate',
        'utils/toast'
    ],

    function ($, settings, FormPoster, View, FormValidator, t, toast) {
        var ProfileInfo = (function () {
            
            function ProfileInfo (container) {
                var _this = this;
                _this.container = container;
                _this.initForm(_this.container);
                _this.initLogoUploader();
                _this.initLogoDeleteButton();                
            }

            ProfileInfo.prototype.initForm = function ($form) {
                var formValidator = new FormValidator($form);
                formValidator.enableValidMsg(true);
                formValidator.removeInputErrorMsgOn('keypress');
                formValidator.validateInputOn('change');

                $form.on('submit', function(e) {
                    if (! formValidator.validateForm() ) {
                        e.preventDefault();
                    }
                });
            };

            ProfileInfo.prototype.initLogoUploader = function () {
                var $form = $('#logoForm');
                            
                if ($form.find('img').length > 0) {
                    $form.find('.link--delete').show();
                }
                
                if ($form.find('img').width() < 1 ) {
                    $form.find('figure').remove();
                }

                new FormPoster($form, {
                    submitOnFileDrop: true,
                    dimPageOnFileDrag: true
                }).on('submit', function () {
                    $form.find('.form-loader').show();
                    $form.find('.link--delete').hide();
                }).on('load', function () {
                    var $img = $form.find('img'), $figure;

                    if ($img.width() < 1 ) {
                        $form.find('figure').remove();
                    }
                    
                    if ($img.length < 1) {                        
                        $figure = $('<figure>').insertBefore('.link--delete');
                        $img = $('<img src="" alt="">').appendTo($figure);
                    }

                    $.getJSON(settings.profileLogoApiUrl, function (data) {
                        $img.attr('src', data.url).on('load', function () {
                            $form.find('.form-loader').hide();
                            $form.find('.link--delete').show();
                        });
                    });
                });
            };

            ProfileInfo.prototype.initLogoDeleteButton = function () {
                var $form = $('#logoForm');

                $('.link--delete').on('click', function () {
                    $form.find('.form-loader').show();

                    $.ajax({
                        url: settings.profileLogoApiUrl,
                        type: 'DELETE',
                        dataType: 'json'
                    }).success(function () {
                        $form.find('figure').remove();
                    }).fail(function () {
                        toast.queueError(t('Logo cannot be deleted. Please try later.'));
                    }).done(function () {
                        $form.find('.form-loader').hide();
                    });
                });
            };

            return ProfileInfo;
        })();

        return View('ProfileInfo', function () {
            var view = new ProfileInfo($('[data-view="ProfileInfo"]'));
        });
    }
);

